import { keyframes } from 'styled-components'
import tw, { styled } from 'twin.macro'

const fadeout = keyframes`
  0%{
    opacity: 1;
  }
  100%{
    opacity: 0;
  }
`

const Toast = styled.div`
  ${tw`fixed p-4 border bg-opacity-90 flex md:hidden`}
  z-index: 99;
  left: 16px;
  right: 16px;
  top: 80px;
  border-radius: 8px;
  line-height: 1;
  pointer-events: none;
  animation: ${fadeout} 0.8s 3s forwards;

  & > svg {
    margin-right: 8px;
    width: 16px;
    height: 16px;
  }
`

export default Toast
